import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from '../auth/authConfig';

// Before showing the interactive "Sign in with Microsoft" button, try a
// silent SSO check first — if the user already has an active Microsoft
// session (e.g. just signed into a sibling NEO module), this authenticates
// with zero clicks via a hidden iframe instead of making them click through
// another sign-in screen. Falls through to the normal button if there's no
// existing session — that's the expected path for a genuinely logged-out
// user, not an error.
function useSsoSilentAttempt() {
  const { instance, inProgress } = useMsal();
  const [attempted, setAttempted] = useState(false);

  useEffect(() => {
    if (attempted || inProgress !== InteractionStatus.None) return;
    instance
      .ssoSilent(loginRequest)
      .catch(() => {})
      .finally(() => setAttempted(true));
  }, [attempted, inProgress, instance]);

  return attempted;
}

export default useSsoSilentAttempt;
